import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";
import { Wrench } from "lucide-react";
import { useTranslation } from "react-i18next";

export const MaintenanceGuard = ({ children }: { children: React.ReactNode }) => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const check = async () => {
      const { data } = await supabase
        .from("platform_settings")
        .select("value")
        .eq("key", "maintenance_mode")
        .maybeSingle();
      setMaintenanceMode(data?.value === "true");
      setChecked(true);
    };
    check();
  }, []);

  // Admins always bypass maintenance mode
  if (!checked) {
    return (
      <div className="min-h-screen bg-[var(--color-navy)] p-4 pt-24" role="status" aria-label={t("common.loading", "Loading")}>
        <div className="mx-auto max-w-6xl space-y-4">
          <div className="h-16 ec-shimmer-dark" />
          <div className="grid grid-cols-2 gap-4"><div className="h-40 ec-shimmer-dark" /><div className="h-40 ec-shimmer-dark" /></div>
          <span className="sr-only">{t("common.loading", "Loading")}</span>
        </div>
      </div>
    );
  }
  if (maintenanceMode && user?.role !== "admin") {
    return (
      <div className="min-h-screen flex items-center justify-center p-4 sm:p-6" style={{ background: "var(--color-navy)" }}>
        <div className="max-w-md text-center space-y-6">
          <div className="w-20 h-20 mx-auto flex items-center justify-center bg-white/10 border border-white/20">
            <Wrench className="h-10 w-10 text-[var(--color-orange)]" />
          </div>
          <h1 className="text-2xl font-bold text-white">{t('maintenance.title')}</h1>
          <p className="text-white/60 leading-relaxed">{t('maintenance.body')}</p>
          <p className="text-xs text-white/30">{t('maintenance.contact')}</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
